// src/theme/tokens/radius.js
// Source of truth for Figma radius tokens

export const radius = {
  s: 4,     // radius-s
  m: 8,     // radius-m
  l: 10,    // radius-l
  xl: 12,   // radius-xl
  xxl: 16,  // radius-2xl
  round: 999, // radius-round
};

